import React from "react";
import Loading from "../../components/LoadingTable";
import Typography from '@mui/material/Typography';
import { GPAP_Button_light } from "../../../../gpap-lib/Button_Collection";
import ReactTable from "react-table";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { CsvButton } from '../../../service/CsvButton'


const BackButton = (props) => {
    if ( props.href !== undefined) {
        return <GPAP_Button_light href={props.href}  startIcon={<ArrowBackIcon />}> Back</GPAP_Button_light>;
    }
    else if ( props.goBack !== undefined ) {
        return <GPAP_Button_light onClick={props.goBack}  startIcon={<ArrowBackIcon />}> Back</GPAP_Button_light>;
    }
    else {
        return <GPAP_Button_light  startIcon={<ArrowBackIcon />}> Back</GPAP_Button_light>;
    }
}


const TableView = (props) => {
    return (
        <div className={"mainContent"}>
            <Typography variant={"h5"} align={"center"}> {props.title} </Typography>
            <BackButton href={props.href} goBack={props.goBack} />
            <CsvButton getCsvData={props.getCsvData} />

            <ReactTable
                data={props.rows}
                filterable
                columns={props.columns}
                defaultPageSize = {100}
                pageSizeOptions = {[100, 200, 300]}
                className="-striped -highlight"
                getTdProps={props.onRowClick}
                style={{ height: props.height }}
                loading={props.loading}
                LoadingComponent={Loading}
            />
        </div>
    );
}

export default TableView;